import Model from '../Model'
import moment from "moment";

export default class DayworksSheet extends Model {
    getFormAttributes() {
        return this;
    }

    static parseAttributes(attributes = {}) {
        return attributes
    }

    getDownloadUrl() {
        return '';
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formatted_date = moment(attributes.date).format('DD/MM/YYYY');

        let tokens = [
            this.formatted_date,
            this.locationOfWorks,
            this.descriptionOfWorks,
            this.name,
        ]
        if (attributes.date) {
            tokens.push(moment(attributes.date).format('MMMM Do, YYYY'))
        }

        this.tokens = tokens.join('|').toLowerCase();
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.project-delivery.dayworks-sheet', [packageReference, id]))
        return this.make(data);
    }

    static async list(packageReference = null) {
        const params = {}
        const data = await Http.get(route('api.v2.project-delivery.dayworks-sheet.list', [packageReference]), {params})
        return this.make(data)
    }

    static async create(packageReference, id, attributes = {}) {
        const success = await Http.post(route('api.v2.project-delivery.dayworks-sheet.create', [packageReference, id]), attributes);
        const data = await Http.get(route('api.v2.project-delivery.dayworks-sheet', [packageReference, id]))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v2.project-delivery.dayworks-sheet.store', [this.packageReference, this.id])
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const success = await Http.put(url, payload)
    }

    async send(attributes = {}) {
        const url = route('api.v2.project-delivery.dayworks-sheet.send', [this.packageReference, this.id])
        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.project-delivery.dayworks-sheet', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }
    async revoke(sendRequestId) {
        const url = route('api.v2.project-delivery.dayworks-sheet.revoke', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.project-delivery.dayworks-sheet', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async resend(sendRequestId) {
        const url = route('api.v2.project-delivery.dayworks-sheet.resend', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.project-delivery.dayworks-sheet', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }
    async requestApproval(attributes = {}) {
        const url = route('api.v2.project-delivery.dayworks-sheet.request-approval', [this.packageReference, this.id])
        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.project-delivery.dayworks-sheet', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async delete() {
        await Http.delete(route('api.v2.project-delivery.dayworks-sheet.delete', [this.packageReference, this.id]))
    }
}
